import React from "react";
import UpdateGeneralSettings from "./updateGeneralSettings";
import RenewCert from "./renewCert";
import DeleteBillingSettings from "./deleteBillingSettings";

export default function Settings() {
  return (
    <div className="p-3">
      <div className="row mb-4">
        <div className="col-sm-3">
          <h4>Datos generales</h4>
        </div>
        <div className="col-sm-9">
          <div className="card shadow-sm">
            <div className="card-body">
              <UpdateGeneralSettings />
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-sm-3">
          <h4>Renovar certificado</h4>
        </div>
        <div className="col-sm-9">
          <div className="card shadow-sm">
            <div className="card-body">
              <RenewCert />
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-sm-3">
          <h4>Eliminar certificado</h4>
        </div>
        <div className="col-sm-9">
          <div className="card shadow-sm">
            <div className="card-body">
              <DeleteBillingSettings />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
